import { METHOD, apiCall } from '../../shared/services/api/baseApiCall';
import {
	CHANGE_PASSWORD_URL,
	FORGET_PASSWORD_URL,
	GET_NOTIFICATION_LIST,
	LOGIN_URL,
	READ_NOTIFICATION
} from '../../shared/services/apiEndPoint';
import { getAPIEndPoint } from '../../shared/utils/utils';
import { AppDispatch, AppThunk } from '../../store';
import {
	changepasswordError,
	changepasswordInIt,
	changepasswordSuccess,
	forgotPasswordError,
	forgotPasswordInit,
	forgotPasswordSucess,
	getHeaderNotificationError,
	getHeaderNotificationInIt,
	getHeaderNotificationSuccess,
	loginError,
	loginInit,
	loginSucess,
	readNotificationInIt
} from '../../store/slices/authSlice';
import { email, userData } from './types/authTypes';

export const login =
	(userData: userData): AppThunk =>
	(dispatch: AppDispatch) => {
		dispatch(loginInit());

		apiCall(
			LOGIN_URL,
			{ ...userData, deviceId: localStorage.getItem('deviceId') || '' },
			(data: any) => {
				dispatch(loginSucess(data));
			},
			() => {
				dispatch(loginError());
			},
			METHOD.POST,
			{ showToast: true }
		);
	};

export const forgotPassword =
	(userData: email): AppThunk =>
	(dispatch: AppDispatch) => {
		dispatch(forgotPasswordInit());

		apiCall(
			FORGET_PASSWORD_URL,
			{ ...userData },
			(data: any) => {
				dispatch(forgotPasswordSucess(data));
			},
			() => {
				dispatch(forgotPasswordError());
			},
			METHOD.POST,
			{ showToast: true }
		);
	};

export const changePassword =
	(values: any): AppThunk =>
	(dispatch: AppDispatch) => {
		dispatch(changepasswordInIt());

		return new Promise<void>((resolve, reject) => {
			apiCall(
				`${CHANGE_PASSWORD_URL}`,
				{ ...values },
				(data: any) => {
					dispatch(changepasswordSuccess());
					resolve(data); // Resolve the promise with the data returned from the API call
				},
				(error: any) => {
					dispatch(changepasswordError());
					reject(error); // Reject the promise with the error from the API call
				},
				METHOD.PUT,
				{ showToast: true }
			);
		});
	};

export const getNotificationListHeader =
	(showToast = false): AppThunk =>
	(dispatch: AppDispatch) => {
		dispatch(getHeaderNotificationInIt());

		// const url = `${GET_NOTIFICATION_LIST}?isAdmin=${isAdmin}`;
		const url = '/notification/get/UnRead';
		apiCall(
			// getAPIEndPoint(url, page, true),
			url,
			{},
			(data: any) => {
				dispatch(getHeaderNotificationSuccess(data));
			},
			() => {
				dispatch(getHeaderNotificationError());
			},
			METHOD.GET,
			{ showToast: showToast }
		);
	};

export const readNotification =
	(notificationIds: any, readedOption: string): AppThunk =>
	dispatch => {
		apiCall(
			`${READ_NOTIFICATION}`,
			{
				notificationIds: notificationIds,
				readedOption: readedOption
			},
			(data: any) => {
				dispatch(getNotificationListHeader());
			},
			() => {
				console.log('');
			},
			METHOD.PATCH,
			{ showToast: true }
		);
	};
